import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import i18n from "@/i18n";
import Users from "@/views/user/Users.vue";
import User from "@/views/user/User.vue";
import Companies from "@/views/company/Companies.vue";
import Company from "@/views/company/Company.vue";
import Export from "@/views/export/Export.vue";
import Reports from "@/views/report/Reports.vue";
import Report from "@/views/report/Report.vue";
import Bills from "@/views/bill/Bills.vue";
import Bill from "@/views/bill/Bill.vue";
import Home from "@/views/home/Home.vue";
import Orders from "@/views/order/Orders.vue";
import Order from "@/views/order/Order.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'pageTitles.home'
		},
	},
	{
		path: '/reports',
		name: 'Reports',
		component: Reports,
		meta: {
			title: 'report.plural'
		},
	},
	{
		path: '/report/:id',
		name: 'Report',
		component: Report,
		props: true,
		meta: {
			title: 'report.singular'
		},
	},
	{
		path: '/companies',
		name: 'Companies',
		component: Companies,
		meta: {
			title: 'company.plural'
		},
	},
	{
		path: '/companies/:id',
		name: 'Company',
		component: Company,
		props: true,
		meta: {
			title: 'company.singular'
		},
	},
	{
		path: '/users',
		name: 'Users',
		component: Users,
		meta: {
			title: 'user.plural'
		},
	},
	{
		path: '/users/:id',
		name: 'User',
		component: User,
		props: true,
		meta: {
			title: 'user.singular'
		},
	},
	{
		path: '/bills',
		name: 'Bills',
		component: Bills,
		meta: {
			title: 'bill.plural'
		},
	},
	{
		path: '/bills/:id',
		name: 'Bill',
		component: Bill,
		props: true,
		meta: {
			title: 'bill.singular'
		},
	},
	{
		path: '/orders',
		name: 'Orders',
		component: Orders,
		meta: {
			title: 'order.plural'
		},
	},
	{
		path: '/orders/:id',
		name: 'Order',
		component: Order,
		props: true,
		meta: {
			title: 'order.singular'
		},
	},
	{
		path: '/export',
		name: 'Export',
		component: Export,
		meta: {
			title: 'ui.export'
		},
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
	let title = i18n.t('pageTitles.application').toString();
	if (to.meta && to.meta.title) {
		title = i18n.t(to.meta.title).toString() + ' | ' + title;
	}
	document.title = title;

	next();
});

export default router
